export const KYC_VERIFY_POPUP_ALERT_ID = "KYC_VERIFY_POPUP_ALERT_ID";
